const initialState = {
    loading: {},
    snackbar: {
        message: "",
        type: "",
        secondaryMessage: ""
    },
    isTouchDevice: true,
    isLoadingApp: false
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case 'TOGGLE_LOADING':
            return { ...state, loading: payload }

        case 'SHOW_SNACKBAR_MESSAGE':
            return { ...state, snackbar: { message: payload && payload.message, type: payload && payload.type, secondaryMessage: payload && payload.secondaryMessage } }

        case 'HIDE_SNACKBAR_MESSAGE':
            return { ...state, snackbar: { message: "", type: "", secondaryMessage: "" } }

        case 'SET_IS_TOUCH_DEVICE_STATUS':
            return { ...state, isTouchDevice: payload }

        case 'TOGGLE_APP_LOADER':
            return { ...state, isLoadingApp: payload }
    
        default:
            return state
    }
}